import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';

import InjectedFrameStyles from './InjectedFrameStyles';
import {
    BreakpointPreviewerContainer,
    StyledFrame,
    BreakpointTag,
    BreakpointTagContainer,
} from './BreakpointPreviewer.styles';
import { useBreakpointManager } from '../../contexts/BreakpointManagerContext/BreakpointManagerContext';
import { TABLET_BREAKPOINT, PHONE_BREAKPOINT } from '../../contexts/BreakpointManagerContext/constants';

const BREAKPOINT_TAG_LABELS = {
    tablet: `Tablet from ${TABLET_BREAKPOINT}px and below`,
    phone: `Mobile from ${PHONE_BREAKPOINT}px and below`,
};

export default function BreakpointPreviewer({ children, enabled }) {
    const breakpointManager = useBreakpointManager();
    const breakpointTagLabel = BREAKPOINT_TAG_LABELS[breakpointManager.status.breakpoint];
    const customFonts = document.getElementById('font-loader')?.innerHTML;

    const stylesheets = useMemo(
        () =>
            [...document?.styleSheets]
                .filter((styleSheetTag) => styleSheetTag.href)
                .map((styleSheetTag) => `<link rel="stylesheet" href="${styleSheetTag.href}" />`),
        [],
    );

    const initialFrameContent = useMemo(
        () => `<!DOCTYPE html>
                <html>
                    <head>
                        ${stylesheets.join('\n')}
                        <style>
                            ${customFonts}
                        </style>
                        <style>
                            body {
                                overflow: auto;
                            }
                            .frame-wrapper, .frame-content {
                                height: 100%;
                            }
                        </style>
                        </head>
                    <body>
                        <div class="frame-wrapper">
                        </div>
                    </body>
                </html>
                `,
        [],
    );

    useEffect(() => {
        if (!enabled) {
            breakpointManager.actions.resetBreakpoint();
        }
    }, [enabled]);

    if (!enabled) {
        return children;
    }

    return (
        <BreakpointPreviewerContainer>
            <BreakpointTagContainer>
                {breakpointTagLabel && <BreakpointTag text={breakpointTagLabel} />}
            </BreakpointTagContainer>
            <StyledFrame
                initialContent={initialFrameContent}
                title="Preview Container"
                $width={enabled && breakpointManager.status.breakpointWidth}
            >
                <InjectedFrameStyles>{children}</InjectedFrameStyles>
            </StyledFrame>
        </BreakpointPreviewerContainer>
    );
}

BreakpointPreviewer.propTypes = {
    children: PropTypes.node.isRequired,
    enabled: PropTypes.bool,
};

BreakpointPreviewer.defaultProps = {
    enabled: false,
};
